import { ifNotAuthenticated } from '../utils/authorization.js';
import Login from '../views/Auth/Login.vue';
import NewPassword from '../views/Auth/NewPassword.vue';

export default [
    // Login
    {
        path: '/login',
        name: 'auth.login',
        component: Login, // Do not use code splitting here.
        props: route => ({ baseEmail: route.query.e }),
        beforeEnter: ifNotAuthenticated,
        meta: {
            auth: true,
            layout: 'auth',
            title: '',
        },
    },

    // Password Reset
    {
        path: '/forgot-password',
        name: 'auth.forgotPassword',
        component: () => import(/* webpackChunkName: "forgot-password" */ '../views/Auth/ForgotPassword.vue'),
        beforeEnter: ifNotAuthenticated,
        meta: {
            auth: true,
            layout: 'auth',
            title: 'auth.forgotPassword.pageTitle',
        },
    },
    {
        path: '/new-password',
        name: 'auth.newPassword',
        component: NewPassword, // Do not use code splitting here.
        props: route => ({ token: route.query.t, email: route.query.e, locale: route.query.l }),
        beforeEnter: ifNotAuthenticated,
        meta: {
            auth: true,
            layout: 'auth',
            title: 'auth.newPassword.pageTitle',
        },
    },
];
